import { render, staticRenderFns } from "./PagedRecords.vue?vue&type=template&id=64f44384&"
import script from "./PagedRecords.vue?vue&type=script&lang=js&"
export * from "./PagedRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports